import React from 'react';
import { isPlanner, isEngineering, canAccessEngineeringModule, canAccessPlanningModule } from '../../utils/roleConstants';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import DataTable from 'react-data-table-component';
import { Navigate } from 'react-router';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import utils from '../../utils';
import UploadFiles from '../../_components/upload-files.component';
import UploadService from '../../_services/upload-files.service';
import MasterPartNoInput from '../../_components/MasterPartNoInput';
import DataTableEllipsisText from '../../_components/DataTableEllipsisText';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';
import { isPartNoCreateEnabled, MASTER_PART_NO_VALIDATION_STATUS } from '../../utils/masterPartNoValidation';

let perPage = 30;

class MasterData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            customer: '',
            partNo: '',
            itemCode: '',
            partDesc: '',
            drawingNo: '',
            drawingRevision: '',
            drawingFiles: [],
            partWeight: '',
            partRunnerWeight: '',
            cycleTime: 0,
            dataInterval: 0,
            MOQ: 0,
            qty: 0,
            rejectionRate: 0,
            offset: 0,
            processList: [], // Array of process strings
            riskClass: 0,
            company: 0,
            products: [],
            body: [],
            pageCount: 0,
            keyword: '',
            modalShow: false,
            newMode: false,
            processes: [],
            currentPage: 1,
            rowsPerPage: 10,
            totalRows: 0,
            clipboardBOM: null,
            clipboardSourcePart: '',
            isPastingBOM: false,
            openDropdownId: null,
            copyModalShow: false,
            copySourceRow: null,
            copySourceChildren: [],
            selectedCopyIds: new Set(),
            partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
            loading: false
        }
        this.tableRequestSeq = 0;
    }

    // Check if the current mode is 'view' (read-only, no Edit/Delete/New buttons)
    // Rules:
    // - Planner users are ALWAYS in view mode (even if URL says ?mode=edit)
    // - Engineering users are in edit mode by default
    // - URL ?mode=view forces view mode for any user
    isViewMode() {
        const user = JSON.parse(localStorage.getItem('user'));
        // Planners always get view mode - they cannot edit/delete
        if (isPlanner(user) && !isEngineering(user)) return true;

        // For Engineering/superadmin, check URL mode
        const hash = window.location.hash; // e.g. "#/masterdata?mode=view"
        const queryIndex = hash.indexOf('?');
        if (queryIndex === -1) return false;
        const params = new URLSearchParams(hash.substring(queryIndex));
        return params.get('mode') === 'view';
    }

    buildColumns() {
        const viewMode = this.isViewMode();
        this.columns = [
            {
                name: 'No',
                selector: row => row.no,
                width: '60px',
            },
            {
                name: 'Customer',
                selector: row => row.customer,
                cell: row => <DataTableEllipsisText value={row.customer} />,
                sortable: true,
            },
            {
                name: 'Part No',
                selector: row => row.partNo,
                cell: row => <DataTableEllipsisText value={row.partNo} />,
                sortable: true,
            },
            {
                name: 'Item Code',
                selector: row => row.itemCode,
                cell: row => <DataTableEllipsisText value={row.itemCode} />,
                sortable: true,
            },
            {
                name: 'Drawing No',
                selector: row => row.drawingNo,
                cell: row => <DataTableEllipsisText value={row.drawingNo} />,
                sortable: true,
            },
            {
                name: 'Drawing Revision',
                selector: row => row.drawingRevision,
                cell: row => <DataTableEllipsisText value={row.drawingRevision} />,
                sortable: true,
            },
            {
                name: 'Part Description',
                selector: row => row.partDesc,
                cell: row => <DataTableEllipsisText value={row.partDesc} />,
                sortable: true,
                minWidth: '260px',
                grow: 2,
            },
            {
                name: '',
                cell: (row, rowIndex) => {
                    if (viewMode) {
                        return (
                            <button
                                style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                                type="button"
                                onClick={() => {
                                    window.location.hash = `#/bomlist/${row.id}?mode=view`;
                                }}
                            >
                                BOM
                            </button>
                        );
                    }
                    const isNearBottom = this.state.products && rowIndex >= this.state.products.length - 4;
                    const isOpen = this.state.openDropdownId === row.id;
                    return (
                        <div className="bom-action-container">
                            <button
                                type="button"
                                title="Actions"
                                className="bom-action-trigger"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({ openDropdownId: isOpen ? null : row.id });
                                }}
                            >
                                ⋮
                            </button>

                            {isOpen && (
                                <div className={`bom-action-menu ${isNearBottom ? 'near-bottom' : ''}`}>
                                    <button className="bom-menu-item" onClick={() => { this.setState({ openDropdownId: null }); this.onClickProductSelected(null, row, rowIndex); }}>
                                        Edit
                                    </button>
                                    <button className="bom-menu-item" onClick={() => window.location.hash = `#/bomlist/${row.id}?mode=edit`}>
                                        BOM List
                                    </button>
                                    <button className="bom-menu-item bom-menu-item--copy" onClick={() => { this.setState({ openDropdownId: null }); this.copyBOM(row); }}>
                                        Copy BOM
                                    </button>
                                    {this.state.clipboardBOM && (
                                        <button 
                                            className="bom-menu-item bom-menu-item--paste" 
                                            disabled={this.state.isPastingBOM}
                                            style={{ opacity: this.state.isPastingBOM ? 0.5 : 1 }}
                                            onClick={() => { this.setState({ openDropdownId: null }); this.pasteBOM(row); }}
                                        >
                                            {this.state.isPastingBOM ? 'Pasting...' : 'Paste BOM'}
                                        </button>
                                    )}
                                    <div style={{ height: '1px', backgroundColor: '#f0f0f0', margin: '4px 0' }} />
                                    <button className="bom-menu-item bom-menu-item--danger" onClick={() => { this.setState({ openDropdownId: null }); window.confirm("Are you sure you delete this data?") && this.onDeleteProduct(null, row, rowIndex); }}>
                                        Delete
                                    </button>
                                </div>
                            )}
                        </div>
                    );
                },
                ignoreRowClick: true,
                allowOverflow: true,
                width: viewMode ? '100px' : '60px',
                minWidth: viewMode ? '100px' : '60px',
            }];
    }

    componentDidMount() {
        this._handleOutsideClick = () => this.setState({ openDropdownId: null });
        document.addEventListener('click', this._handleOutsideClick);

        if (!document.getElementById('bom-action-styles-masterdata')) {
            const style = document.createElement('style');
            style.id = 'bom-action-styles-masterdata';
            style.textContent = `
                #datatable, #datatable * {
                    overflow: visible !important;
                }
                .rdt_Table, .rdt_TableBody, .rdt_TableRow, .rdt_TableCell, .rdt_TableCol, .rdt_TableCol_Content {
                    overflow: visible !important;
                }
                
                /* Ensure active row with z-index 100 stays above the header/footer */
                .rdt_TableHead { z-index: 10 !important; }
                .rdt_Pagination { position: relative; z-index: 0 !important; overflow: visible !important; }

                .bom-action-container {
                    position: static !important;
                    display: inline-block;
                }
                .bom-action-trigger {
                    width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px;
                    line-height: 1;
                    font-weight: 700;
                    cursor: pointer;
                    border: 1px solid #ced4da;
                    border-radius: 6px;
                    background-color: #fff;
                    color: #495057;
                    letter-spacing: 1px;
                    padding-bottom: 4px;
                    transition: background-color 0.15s, box-shadow 0.15s;
                }
                .bom-action-trigger:hover {
                    background-color: #f1f3f5;
                    border-color: #adb5bd;
                }
                .bom-action-menu {
                    position: absolute;
                    top: 36px;
                    right: 0;
                    z-index: 9999;
                    background-color: #fff;
                    border: 1px solid #dee2e6;
                    border-radius: 8px;
                    box-shadow: 0 6px 20px rgba(0,0,0,0.12);
                    min-width: 160px;
                    padding: 4px 0;
                }
                .bom-action-menu.near-bottom {
                    top: auto;
                    bottom: 36px;
                }
                .bom-menu-item {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    width: 100%;
                    padding: 8px 14px;
                    text-align: left;
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    font-size: 13px;
                    color: #333;
                    white-space: nowrap;
                    transition: background-color 0.12s;
                }
                .bom-menu-item:hover {
                    background-color: #f8f9fa;
                }
                .bom-menu-item--danger { color: #dc3545; }
                .bom-menu-item--danger:hover { background-color: #fff5f5; color: #b02a37; }
                .bom-menu-item--copy { color: #6f42c1; }
                .bom-menu-item--copy:hover { background-color: #f3eeff; }
                .bom-menu-item--paste { color: #198754; }
                .bom-menu-item--paste:hover { background-color: #eafaf1; }
            `;
            document.head.appendChild(style);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._handleOutsideClick);
    }

    copyBOM = async (row) => {
        try {
            const response = await fetch(`${config.apiUrl}/getBomList?master_data_id=${row.id}&limit=9999&offset=0`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            });
            const text = await response.text();
            const body = text && JSON.parse(text);
            const dataArray = body.data ? body.data : (Array.isArray(body) ? body : []);
            if (dataArray.length === 0) {
                window.alert(`No BOM found for ${row.partNo}.`);
                return;
            }
            
            const allIds = new Set(dataArray.map(c => c.id));
            this.setState({ 
                copyModalShow: true, 
                copySourceRow: row,
                copySourceChildren: dataArray,
                selectedCopyIds: allIds 
            });
        } catch (err) {
            console.error('Error fetching BOM:', err);
            window.alert('Error fetching BOM.');
        }
    }

    handleCopyConfirm = () => {
        const { copySourceChildren, selectedCopyIds, copySourceRow } = this.state;
        const selected = copySourceChildren.filter(c => selectedCopyIds.has(c.id));
        if (selected.length === 0) {
            window.alert('Please select at least one BOM item to copy.');
            return;
        }
        this.setState({ 
            clipboardBOM: selected, 
            clipboardSourcePart: copySourceRow.partNo,
            copyModalShow: false 
        });
        window.alert(`${selected.length} root BOM item(s) copied to clipboard.`);
    }

    pasteBOMRecursive = async (items, targetMasterDataId, parentId = null) => {
        for (const item of items) {
            const body = {
                material: item.material,
                materialDesc: item.materialDesc,
                color: item.color,
                code: item.code,
                usage: item.usage,
                uom: item.uom,
                per: item.per,
                where_use: item.where_use,
                source: item.source,
                category: item.category,
                supplier: item.supplier,
                master_data_id: targetMasterDataId,
                parent_bom_id: parentId,
            };
            const response = await fetch(`${config.apiUrl}/uploadBomList`, {
                method: 'post',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });
            if (response.status === 200) {
                let newId = null;
                try {
                    const data = await response.json();
                    newId = data && (data.id || data.insertId || data.newId);
                } catch (e) { }
                if (newId && item.children && item.children.length > 0) {
                    await this.pasteBOMRecursive(item.children, targetMasterDataId, newId);
                }
            }
        }
    }

    pasteBOM = async (row) => {
        const { clipboardBOM, clipboardSourcePart } = this.state;
        if (!clipboardBOM || clipboardBOM.length === 0) return;
        
        if (!window.confirm(`Paste BOM from ${clipboardSourcePart} into ${row.partNo}?\nThis will append to existing BOM.`)) return;
        
        this.setState({ isPastingBOM: true });
        try {
            await this.pasteBOMRecursive(clipboardBOM, row.id);
            this.setState({ isPastingBOM: false });
            window.alert('BOM pasted successfully.');
        } catch (e) {
            console.error('Error pasting BOM:', e);
            this.setState({ isPastingBOM: false });
            window.alert('Error pasting BOM. Please try again.');
        }
    }

    componentWillMount() {

        this.setState({
            processes: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            fetch(`${config.apiUrl}/getAllProcesses`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(process => {
                    // login successful if there's a user in the response
                    if (process) {
                        this.setState({ processes: process });

                    }

                    return process;
                });
            this.buildHtmlTable();
        }

    }

    exportExcel() {
        utils.tableToExcel('master-data-export-table', 'masterdata', 'Masterdata_' + moment().format('YYYYMMDD') + '.xls');
    };

    parseDrawingFiles(value) {
        if (!value) return [];
        if (Array.isArray(value)) return value;
        if (typeof value !== 'string') return [];
        try {
            const parsed = JSON.parse(value);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }

    stringifyDrawingFiles(files) {
        return JSON.stringify(this.parseDrawingFiles(files));
    }

    getDrawingFileUrl(file) {
        if (!file) return '';
        const rawPath = file.imgPath || file.url || file.path || '';
        if (!rawPath) return '';
        if (/^https?:\/\//i.test(rawPath)) return rawPath;
        const cleanPath = rawPath.replace(/^\/+/, '');
        if (cleanPath.indexOf('img/') === 0) return cleanPath;
        return `img/${cleanPath.split(/[\\/]/).pop()}`;
    }

    removeDrawingFile(index) {
        const drawingFiles = this.parseDrawingFiles(this.state.drawingFiles).filter((_, i) => i !== index);
        this.setState({ drawingFiles });
    }

    uploadDrawingFiles(event) {
        const selectedFiles = event.target.files;
        if (!selectedFiles || selectedFiles.length === 0) return;

        UploadService.uploadImage(selectedFiles)
            .then((response) => {
                const uploadedFiles = Array.isArray(response.data) ? response.data : [];
                const nextFiles = uploadedFiles.map(file => ({
                    originalname: file.originalname || file.filename || 'Drawing',
                    filename: file.filename || '',
                    imgPath: file.imgPath || (file.filename ? `img/${file.filename}` : ''),
                    mimetype: file.mimetype || '',
                    size: file.size || 0,
                    drawingRevision: this.state.drawingRevision || '',
                    uploadedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                }));
                this.setState({
                    drawingFiles: [...this.parseDrawingFiles(this.state.drawingFiles), ...nextFiles],
                });
            })
            .catch(() => {
                window.alert('Could not upload drawing file.');
            });
    }


    // Helper function to parse processes from database
    // Supports both new format (process column) and legacy format (process1-5)
    parseProcesses(data) {
        if (!data) return [];

        // Check if new format exists and has content
        if (data.process && data.process.trim() !== '') {
            // New format: comma-separated string
            return data.process.split(',').filter(p => p && p.trim() !== '');
        }

        // For DataTable's row data, it will be an array. Caller is onClickProductSelected
        if (data.processList && Array.isArray(data.processList)) {
            return data.processList;
        }

        // Legacy format: process1-5 (fallback if process is empty or doesn't exist)
        const processes = [];
        if (data.process1 && data.process1.trim() !== '') processes.push(data.process1.trim());
        if (data.process2 && data.process2.trim() !== '') processes.push(data.process2.trim());
        if (data.process3 && data.process3.trim() !== '') processes.push(data.process3.trim());
        if (data.process4 && data.process4.trim() !== '') processes.push(data.process4.trim());
        if (data.process5 && data.process5.trim() !== '') processes.push(data.process5.trim());
        return processes;
    }

    buildHtmlTable(page = null, limit = null) {
        const { tableStyle, tableHeader } = this.state;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        // Use provided page/limit or state values
        const currentPage = page !== null ? page : this.state.currentPage;
        const rowsPerPage = limit !== null ? limit : this.state.rowsPerPage;
        const offset = (currentPage - 1) * rowsPerPage;
        const requestSeq = ++this.tableRequestSeq;
        this.setState({ loading: true });

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getMasterDataByCompany?company=${JSON.parse(localStorage.getItem('user')).accountId}&keyword=${this.state.keyword || ''}&limit=${rowsPerPage}&offset=${offset}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(body => {
                    if (requestSeq !== this.tableRequestSeq) return;

                    // login successful if there's a user in the response
                    let array = [];
                    const products = [];

                    // Ensure body.data exists and is an array
                    if (body && body.data && Array.isArray(body.data)) {
                        const currentPage = page !== null ? page : this.state.currentPage;
                        const rowsPerPage = limit !== null ? limit : this.state.rowsPerPage;
                        const offset = (currentPage - 1) * rowsPerPage;

                        body.data.map((data, index) => {
                            array.push({
                                no: index + offset + 1,
                                id: data.id,
                                customer: data.customer,
                                partNo: data.partNo,
                                itemCode: data.itemCode,
                                partDesc: data.partDesc,
                                drawingNo: data.drawingNo,
                                drawingRevision: data.drawingRevision,
                                drawingFiles: this.parseDrawingFiles(data.drawingFiles),
                                partWeight: data.partWeight,
                                partRunnerWeight: data.partRunnerWeight,
                                cycleTime: data.cycleTime,
                                dataInterval: data.dataInterval,
                                MOQ: data.MOQ,
                                qty: data.qty,
                                rejectionRate: data.rejectionRate,
                                // Parse process from comma-separated string or legacy process1-5 fields
                                processList: this.parseProcesses(data),
                                riskClass: data.riskClass,
                                company: data.company
                            })
                        });

                        this.setState({
                            products: array,
                            body: body.data,
                            totalRows: body.meta && body.meta.total_count ? body.meta.total_count : 0,
                            currentPage: currentPage,
                            rowsPerPage: rowsPerPage,
                            offset: offset,
                            loading: false
                        });
                    } else {
                        this.setState({
                            products: [],
                            body: [],
                            totalRows: 0,
                            loading: false
                        });
                    }
                })
                .catch(error => {
                    if (requestSeq === this.tableRequestSeq) {
                        this.setState({ loading: false });
                    }
                    throw error;
                });

        this.setState({ loading: false });
        return Promise.resolve();
    }


    onClickProductSelected(cell, row, rowIndex) {
        // Use the row object directly - it contains the correct data for the clicked row
        // Note: rowIndex should NOT be used to look up in this.state.body because:
        // - After sorting, the visual rowIndex doesn't match the original data array order
        // - After pagination changes, the data array is re-fetched
        const originalData = row;

        // Ensure all values are properly initialized to prevent React errors
        const safeString = (val) => {
            if (val == null || val === undefined) return '';
            const str = String(val);
            return str === 'null' || str === 'undefined' ? '' : str;
        };
        const safeNumber = (val) => {
            if (val == null || val === undefined || val === '') return 0;
            const num = Number(val);
            return isNaN(num) ? 0 : num;
        };
        const safeStringNumber = (val) => {
            if (val == null || val === undefined || val === '') return '';
            const str = String(val);
            return str === 'null' || str === 'undefined' ? '' : str;
        };

        // Parse processes from original data which should have process1-5 fields
        const parsedProcesses = this.parseProcesses(originalData) || [];

        // Set ALL form values first, then show modal in next tick to ensure values are set
        this.setState({
            newMode: false,
            customer: safeString(originalData.customer),
            partNo: safeString(originalData.partNo),
            itemCode: safeString(originalData.itemCode),
            partDesc: safeString(originalData.partDesc),
            drawingNo: safeString(originalData.drawingNo),
            drawingRevision: safeString(originalData.drawingRevision),
            drawingFiles: this.parseDrawingFiles(originalData.drawingFiles),
            partWeight: safeStringNumber(originalData.partWeight),
            partRunnerWeight: safeStringNumber(originalData.partRunnerWeight),
            cycleTime: safeNumber(originalData.cycleTime),
            dataInterval: safeNumber(originalData.dataInterval),
            MOQ: safeNumber(originalData.MOQ),
            qty: safeNumber(originalData.qty),
            rejectionRate: safeNumber(originalData.rejectionRate),
            processList: parsedProcesses,
            riskClass: safeNumber(originalData.riskClass),
            id: safeNumber(originalData.id),
            company: safeNumber(originalData.company)
        }, () => {
            // After state is updated, show modal in next tick
            setTimeout(() => {
                this.setState({ modalShow: true });
            }, 0);
        });
    }

    onDeleteProduct(cell, row, rowIndex) {
        fetch(`${config.apiUrl}/deleteMasterData`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                id: row.id,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                }
            });
    }

    cellButton(cell, row, enumObject, rowIndex) {
        return (
            <div>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        this.onClickProductSelected(cell, row, rowIndex)}
                >
                    Edit
                </button>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        window.confirm("Are you sure you delete this data?") && this.onDeleteProduct(cell, row, rowIndex)}
                >
                    Delete
                </button>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() => {
                        this.props.history.push(`/bomlist/${this.state.body[rowIndex].id}`);
                    }
                    }
                >
                    BOM List
                </button>
            </div>
        )
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page }, () => {
            this.buildHtmlTable(page, this.state.rowsPerPage);
        });
    };

    handleRowsPerPageChange = (newRowsPerPage, page) => {
        this.setState({ rowsPerPage: newRowsPerPage, currentPage: page }, () => {
            this.buildHtmlTable(page, newRowsPerPage);
        });
    };

    handlePartNoValidationChange = (partNoValidationStatus) => {
        this.setState({ partNoValidationStatus });
    };

    handlePartDataMatch = (part) => {
        this.setState({
            partDesc: part && part.description ? part.description : '',
            customer: part && (part.customer || part.customerPartNo) ? (part.customer || part.customerPartNo) : '',
        });
    };

    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!canAccessPlanningModule(user) && !canAccessEngineeringModule(user)) {
            return <Navigate to='/' />
        }
        let { keyword, modalShow, newMode, products } = this.state;
        // Rebuild columns on every render so Edit/Delete buttons reflect the current URL mode
        this.buildColumns();
        // Compute safe values that are ALWAYS defined (never undefined or null) to prevent controlled/uncontrolled errors
        // Use strict type checking to ensure we never pass undefined to inputs
        const customer = (this.state.customer !== undefined && this.state.customer !== null) ? String(this.state.customer) : '';
        const partNo = (this.state.partNo !== undefined && this.state.partNo !== null) ? String(this.state.partNo) : '';
        const itemCode = (this.state.itemCode !== undefined && this.state.itemCode !== null) ? String(this.state.itemCode) : '';
        const partDesc = (this.state.partDesc !== undefined && this.state.partDesc !== null) ? String(this.state.partDesc) : '';
        const drawingNo = (this.state.drawingNo !== undefined && this.state.drawingNo !== null) ? String(this.state.drawingNo) : '';
        const drawingRevision = (this.state.drawingRevision !== undefined && this.state.drawingRevision !== null) ? String(this.state.drawingRevision) : '';
        const drawingFiles = this.parseDrawingFiles(this.state.drawingFiles);
        const partWeight = (this.state.partWeight !== undefined && this.state.partWeight !== null) ? String(this.state.partWeight) : '';
        const partRunnerWeight = (this.state.partRunnerWeight !== undefined && this.state.partRunnerWeight !== null) ? String(this.state.partRunnerWeight) : '';
        const cycleTime = (this.state.cycleTime !== undefined && this.state.cycleTime !== null && !isNaN(Number(this.state.cycleTime))) ? Number(this.state.cycleTime) : 0;
        const dataInterval = (this.state.dataInterval !== undefined && this.state.dataInterval !== null && !isNaN(Number(this.state.dataInterval))) ? Number(this.state.dataInterval) : 0;
        const MOQ = (this.state.MOQ !== undefined && this.state.MOQ !== null && !isNaN(Number(this.state.MOQ))) ? Number(this.state.MOQ) : 0;
        const qty = (this.state.qty !== undefined && this.state.qty !== null && !isNaN(Number(this.state.qty))) ? Number(this.state.qty) : 0;
        const rejectionRate = (this.state.rejectionRate !== undefined && this.state.rejectionRate !== null && !isNaN(Number(this.state.rejectionRate))) ? Number(this.state.rejectionRate) : 0;
        const processList = Array.isArray(this.state.processList) ? this.state.processList : [];
        const riskClass = (this.state.riskClass !== undefined && this.state.riskClass !== null && !isNaN(Number(this.state.riskClass))) ? Number(this.state.riskClass) : 0;
        let handleClose = () => {
            this.setState({
                modalShow: false,
                // Reset all form fields to initial values to prevent controlled/uncontrolled errors
                customer: '',
                partNo: '',
                itemCode: '',
                partDesc: '',
                drawingNo: '',
                drawingRevision: '',
                drawingFiles: [],
                partWeight: '',
                partRunnerWeight: '',
                cycleTime: 0,
                dataInterval: 0,
                MOQ: 0,
                qty: 0,
                rejectionRate: 0,
                processList: [],
                riskClass: 0,
                id: 0,
                partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE
            });
        };
        let handleSave = () => {
            const currentUser = JSON.parse(localStorage.getItem('user'));
            const updatedByName = currentUser.firstName || currentUser.lastName
                ? `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim()
                : currentUser.username;

            window.confirm("Are you sure you update this data?") && fetch(`${config.apiUrl}/updateMasterData`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    customer,
                    partNo,
                    itemCode,
                    partDesc,
                    drawingNo,
                    drawingRevision,
                    drawingFiles: this.stringifyDrawingFiles(drawingFiles),
                    partWeight,
                    partRunnerWeight,
                    cycleTime,
                    dataInterval,
                    MOQ,
                    qty,
                    rejectionRate,
                    process: processList.filter(p => p && p.trim() !== '').join(','),
                    riskClass,
                    id: this.state.id,
                    updatedBy: currentUser.id || currentUser.accountId || currentUser.username,
                    updatedByName,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        window.alert('Update Successfully.');

                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    }
                });
        }

        let handleCreate = () => {
            fetch(`${config.apiUrl}/uploadMasterData`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    customer,
                    partNo,
                    itemCode,
                    partDesc,
                    drawingNo,
                    drawingRevision,
                    drawingFiles: this.stringifyDrawingFiles(drawingFiles),
                    partWeight,
                    partRunnerWeight,
                    cycleTime,
                    dataInterval,
                    MOQ,
                    qty,
                    rejectionRate,
                    process: processList.filter(p => p && p.trim() !== '').join(','),
                    riskClass,
                    company: JSON.parse(localStorage.getItem('user')).accountId,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.setState({ modalShow: false });
                        this.setState({ newMode: false });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    }
                });
        }

        return (
            <div class="container">
                <div style={{
                    marginBottom: '20px',
                    position: 'relative',
                    minHeight: '50px',
                    padding: '16px',
                    margin: '16px 0'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap',
                        padding: '12px'
                    }}>
                        <FormGroup controlId="formInlineName">
                            <FormControl
                                type="text"
                                placeholder="Search..."
                                onChange={ev => { this.setState({ keyword: ev.target.value }) }}
                                value={keyword || ''}
                                style={{ minWidth: '200px' }}
                            />
                        </FormGroup>
                        <Button
                            bsStyle="primary"
                            onClick={e => {
                                this.setState({ currentPage: 1, offset: 0 }, () => {
                                    this.buildHtmlTable(1, this.state.rowsPerPage);
                                });
                            }}>Search</Button>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.exportExcel()}>Export</Button>
                        {!this.isViewMode() && (
                            <Button
                                bsStyle="danger"
                                onClick={e => {
                                    // Set ALL values including formReady and modalShow in a single setState call
                                    this.setState({
                                        customer: '',
                                        partNo: '',
                                        itemCode: '',
                                        partDesc: '',
                                        drawingNo: '',
                                        drawingRevision: '',
                                        drawingFiles: [],
                                        partWeight: '',
                                        partRunnerWeight: '',
                                        cycleTime: 0,
                                        dataInterval: 0,
                                        MOQ: 0,
                                        qty: 0,
                                        rejectionRate: 0,
                                        processList: [],
                                        riskClass: 0,
                                        id: 0,
                                        partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
                                        newMode: true,
                                        modalShow: true
                                    });
                                }}>New</Button>
                        )}
                    </div>
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                {/* Clipboard toolbar */}
                {this.state.clipboardBOM && this.state.clipboardBOM.length > 0 && (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '10px 16px',
                        margin: '0 16px 16px 16px',
                        backgroundColor: '#e8f4fd',
                        border: '1px solid #90cdf4',
                        borderRadius: '6px',
                        fontSize: '14px',
                    }}>
                        <span style={{ fontSize: '20px' }}>📋</span>
                        <span>
                            <strong>{this.state.clipboardBOM.length}</strong> BOM item(s) from <strong>{this.state.clipboardSourcePart}</strong> ready to paste.
                            Click <strong style={{ color: '#198754' }}>Paste BOM</strong> on any row to append them.
                        </span>
                        <button
                            type="button"
                            onClick={() => this.setState({ clipboardBOM: null, isPastingBOM: false })}
                            style={{ marginLeft: 'auto', padding: '4px 12px', fontSize: '12px', cursor: 'pointer', backgroundColor: 'transparent', border: '1px solid #90cdf4', borderRadius: '4px', color: '#555' }}
                        >
                            Clear Clipboard
                        </button>
                    </div>
                )}
                <div id="datatable" className="container" style={{ overflow: 'visible' }} >
                    <DataTable
                        columns={this.columns}
                        data={products || []}
                        progressPending={this.state.loading}
                        progressComponent={<DatacoLoadingIndicator loading={this.state.loading} size="compact" label="Loading master data" />}
                        pagination
                        paginationServer
                        paginationTotalRows={this.state.totalRows}
                        paginationPerPage={this.state.rowsPerPage}
                        paginationDefaultPage={this.state.currentPage}
                        onChangePage={this.handlePageChange}
                        onChangeRowsPerPage={this.handleRowsPerPageChange}
                        highlightOnHover
                        conditionalRowStyles={[
                            {
                                when: row => row.id === this.state.openDropdownId,
                                style: {
                                    zIndex: 100,
                                    position: 'relative',
                                },
                            },
                        ]}
                    />
                </div>
                {/* Hidden export table for Excel */}
                <div id="master-data-export-table" style={{ display: 'none' }}>
                    <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ padding: '6px' }}>No</th>
                                <th style={{ padding: '6px' }}>Customer</th>
                                <th style={{ padding: '6px' }}>Part No</th>
                                <th style={{ padding: '6px' }}>Item Code</th>
                                <th style={{ padding: '6px' }}>Drawing No</th>
                                <th style={{ padding: '6px' }}>Drawing Revision</th>
                                <th style={{ padding: '6px' }}>Part Description</th>
                                <th style={{ padding: '6px' }}>Part Weight</th>
                                <th style={{ padding: '6px' }}>Part Runner Weight</th>
                                <th style={{ padding: '6px' }}>Cycle Time</th>
                                <th style={{ padding: '6px' }}>Data Interval</th>
                                <th style={{ padding: '6px' }}>MOQ</th>
                                <th style={{ padding: '6px' }}>Qty</th>
                                <th style={{ padding: '6px' }}>Rejection Rate</th>
                                <th style={{ padding: '6px' }}>Processes</th>
                                <th style={{ padding: '6px' }}>Risk Class</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(this.state.body || []).map((item, index) => (
                                <tr key={item.id || index}>
                                    <td style={{ padding: '4px' }}>{index + 1}</td>
                                    <td style={{ padding: '4px' }}>{item.customer || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.itemCode || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.drawingNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.drawingRevision || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partDesc || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partWeight || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partRunnerWeight || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.cycleTime || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.dataInterval || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.MOQ || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.qty || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.rejectionRate || ''}</td>
                                    <td style={{ padding: '4px' }}>
                                        {Array.isArray(item.processList) ? item.processList.join(', ') : ''}
                                    </td>
                                    <td style={{ padding: '4px' }}>{item.riskClass || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {modalShow && (
                    <Modal size="lg" show={modalShow} onHide={handleClose}
                        aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w"
                        key={`modal-${this.state.id || 'new'}`}>
                        <Modal.Header closeButton>
                            {newMode ? (<Modal.Title>New Master Data</Modal.Title>) : (<Modal.Title>Edit Master Data</Modal.Title>)}
                        </Modal.Header>
                        <Modal.Body>
                            {(() => {
                                // Ensure all values are defined before rendering form
                                const allValuesReady =
                                    customer !== undefined && partNo !== undefined && itemCode !== undefined && partDesc !== undefined &&
                                    drawingNo !== undefined && drawingRevision !== undefined && drawingFiles !== undefined &&
                                    partWeight !== undefined && partRunnerWeight !== undefined &&
                                    cycleTime !== undefined && dataInterval !== undefined && MOQ !== undefined && qty !== undefined &&
                                    rejectionRate !== undefined && processList !== undefined && riskClass !== undefined;

                                if (!allValuesReady) return <div>Loading...</div>;

                                return (
                                    <div>
                                        <Form>
                                            <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Customer</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ customer: ev.target.value }) }} value={customer} /></Col>
                                                <Col sm={3}><Form.Label>Part No</Form.Label></Col>
                                                <Col sm={3}>
                                                    <MasterPartNoInput
                                                        value={partNo}
                                                        onChange={value => this.setState({ partNo: value })}
                                                        enabled={true}
                                                        onValidationChange={this.handlePartNoValidationChange}
                                                        onPartDataMatch={this.handlePartDataMatch}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Part Description</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ partDesc: ev.target.value }) }} value={partDesc} /></Col>
                                                <Col sm={3}><Form.Label>Item Code</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ itemCode: ev.target.value }) }} value={itemCode} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlineDrawing" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Drawing No</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ drawingNo: ev.target.value }) }} value={drawingNo} /></Col>
                                                <Col sm={3}><Form.Label>Drawing Revision</Form.Label></Col>
                                                <Col sm={3}><FormControl type="text" onChange={ev => { this.setState({ drawingRevision: ev.target.value }) }} value={drawingRevision} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlineDrawingUpload" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Drawing Upload</Form.Label></Col>
                                                <Col sm={9}>
                                                    {drawingFiles.length > 0 && (
                                                        <ul className="file-list" style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '8px 12px', marginBottom: '10px' }}>
                                                            {drawingFiles.map((file, i) => (
                                                                <li key={`${file.filename || file.originalname || 'drawing'}-${i}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0' }}>
                                                                    <a href={this.getDrawingFileUrl(file)} target="_blank" rel="noreferrer" style={{ flex: 1, marginRight: '10px' }}>
                                                                        {file.originalname || file.filename || `Drawing ${i + 1}`}
                                                                        {file.drawingRevision ? ` - Rev ${file.drawingRevision}` : ''}
                                                                        {file.uploadedAt ? ` (${file.uploadedAt})` : ''}
                                                                    </a>
                                                                    <button
                                                                        type="button"
                                                                        style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '3px', padding: '5px 10px', cursor: 'pointer', fontSize: '12px' }}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            this.removeDrawingFile(i);
                                                                        }}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                    <UploadFiles onUpload={this.uploadDrawingFiles.bind(this)} />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlineCustomer" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Part Weight(kg)</Form.Label></Col>
                                                <Col sm={3}><FormControl type="number" step="0.001" min="0" max="10" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ partWeight: ev.target.value }) }} value={partWeight} /></Col>
                                                <Col sm={3}><Form.Label>Cycle Time(s)</Form.Label></Col>
                                                <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ cycleTime: Number(ev.target.value) || 0 }) }} value={cycleTime} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Part Runner Weight(kg)</Form.Label></Col>
                                                <Col sm={3}><FormControl type="number" step="0.001" min="0" max="10" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ partRunnerWeight: ev.target.value }) }} value={partRunnerWeight} /></Col>
                                                <Col sm={3}><Form.Label>Data Time Interval(h)</Form.Label></Col>
                                                <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ dataInterval: Number(ev.target.value) || 0 }) }} value={dataInterval} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>MOQ</Form.Label></Col>
                                                <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ MOQ: Number(ev.target.value) || 0 }) }} value={MOQ} /></Col>
                                                <Col sm={3}><Form.Label>Qty per Carton</Form.Label></Col>
                                                <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ qty: Number(ev.target.value) || 0 }) }} value={qty} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Rejection Rate%</Form.Label></Col>
                                                <Col sm={3}><FormControl type="number" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ rejectionRate: Number(ev.target.value) || 0 }) }} value={rejectionRate} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlineProcesses" style={{ marginBottom: '15px' }}>
                                                <Col sm={12}>
                                                    <Form.Label style={{ marginBottom: '10px', fontWeight: 'bold' }}>Processes</Form.Label>
                                                    {processList && processList.length > 0 ? processList.map((process, index) => (
                                                        <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center' }}>
                                                            <Col sm={4}>
                                                                <FormControl as="select"
                                                                    value={process || 'select'}
                                                                    onChange={(e) => {
                                                                        const newList = [...processList];
                                                                        if (e.target.value !== 'select') {
                                                                            newList[index] = e.target.value;
                                                                        } else {
                                                                            newList[index] = '';
                                                                        }
                                                                        this.setState({ processList: newList });
                                                                    }}>
                                                                    <option value="select">select</option>
                                                                    {
                                                                        (this.state.processes || []).map((proc) => {
                                                                            return <option key={proc.id} value={proc.description}>{proc.description}</option>
                                                                        })
                                                                    }
                                                                </FormControl>
                                                            </Col>
                                                            <Col sm={6}>
                                                                <FormControl
                                                                    type="text"
                                                                    placeholder="Or enter custom process"
                                                                    value={process || ''}
                                                                    onChange={(ev) => {
                                                                        const newList = [...processList];
                                                                        newList[index] = ev.target.value;
                                                                        this.setState({ processList: newList });
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col sm={2}>
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        const newList = processList.filter((_, i) => i !== index);
                                                                        this.setState({ processList: newList });
                                                                    }}
                                                                >
                                                                    Remove
                                                                </Button>
                                                            </Col>
                                                        </div>
                                                    )) : (
                                                        <div style={{ marginBottom: '10px', color: '#666', fontStyle: 'italic' }}>
                                                            No processes added yet. Click "Add Process" to add one.
                                                        </div>
                                                    )}
                                                    <Button
                                                        variant="success"
                                                        size="sm"
                                                        onClick={() => {
                                                            this.setState({ processList: [...processList, ''] });
                                                        }}
                                                        style={{ marginTop: '10px' }}
                                                    >
                                                        + Add Process
                                                    </Button>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Risk Class</Form.Label></Col>
                                                <Col sm={3}> <FormControl as="select" placeholder="select"
                                                    value={String(riskClass)} onChange={(e) => {
                                                        if (e.target.value != 'select' && e.target.value != '') {
                                                            this.setState({ riskClass: Number(e.target.value) });
                                                        } else {
                                                            this.setState({ riskClass: 0 });
                                                        }
                                                    }}>
                                                    <option value="select">select</option>
                                                    <option key={1} value="1">Low</option>
                                                    <option key={2} value="2">Medium</option>
                                                    <option key={3} value="3">High</option>
                                                </FormControl></Col>
                                            </FormGroup>
                                        </Form>
                                    </div>
                                );
                            })()}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            {newMode && (<Button variant="primary" onClick={handleCreate} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                                Create
                            </Button>)}

                            {!newMode && (<Button variant="primary" onClick={handleSave} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                                Save Changes
                            </Button>)}
                        </Modal.Footer>
                    </Modal>
                )}

                {/* ---- Copy BOM Selection Modal ---- */}
                <Modal
                    size="lg"
                    show={this.state.copyModalShow}
                    onHide={() => this.setState({ copyModalShow: false })}
                    aria-labelledby="copy-modal-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="copy-modal-title">
                            Copy BOM from "{this.state.copySourceRow ? this.state.copySourceRow.partNo : ''}"
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {(this.state.copySourceChildren || []).length === 0 ? (
                            <p style={{ color: '#666' }}>No direct BOM items found for this row.</p>
                        ) : (
                            <React.Fragment>
                                <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', alignItems: 'center', padding: '0 8px' }}>
                                    <input
                                        type="checkbox"
                                        id="copy-select-all"
                                        checked={(this.state.copySourceChildren || []).length > 0 && this.state.selectedCopyIds.size === (this.state.copySourceChildren || []).length}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                const allIds = new Set((this.state.copySourceChildren || []).map(c => c.id));
                                                this.setState({ selectedCopyIds: allIds });
                                            } else {
                                                this.setState({ selectedCopyIds: new Set() });
                                            }
                                        }}
                                        style={{ width: '16px', height: '16px', cursor: 'pointer', margin: 0 }}
                                    />
                                    <label htmlFor="copy-select-all" style={{ margin: 0, cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}>
                                        Select All
                                    </label>
                                    <span style={{ marginLeft: 'auto', fontSize: '13px', color: '#666' }}>
                                        {this.state.selectedCopyIds.size} / {(this.state.copySourceChildren || []).length} selected
                                    </span>
                                </div>

                                <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                                    {(this.state.copySourceChildren || []).map((child, idx) => (
                                        <div
                                            key={child.id}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '10px 14px',
                                                borderBottom: idx < (this.state.copySourceChildren.length - 1) ? '1px solid #f0f0f0' : 'none',
                                                backgroundColor: this.state.selectedCopyIds.has(child.id) ? '#f0f7ff' : '#fff',
                                                transition: 'background-color 0.15s',
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                id={`copy-child-${child.id}`}
                                                checked={this.state.selectedCopyIds.has(child.id)}
                                                onChange={(e) => {
                                                    const newSet = new Set(this.state.selectedCopyIds);
                                                    if (e.target.checked) newSet.add(child.id);
                                                    else newSet.delete(child.id);
                                                    this.setState({ selectedCopyIds: newSet });
                                                }}
                                                style={{ marginRight: '12px', width: '16px', height: '16px', cursor: 'pointer', flexShrink: 0 }}
                                            />
                                            <label htmlFor={`copy-child-${child.id}`} style={{ margin: 0, cursor: 'pointer', flex: 1 }}>
                                                <span style={{ fontWeight: '600' }}>{child.material || '(unnamed)'}</span>
                                                {child.children && child.children.length > 0 && (
                                                    <span style={{ marginLeft: '8px', fontSize: '0.8em', color: '#0d6efd', fontStyle: 'italic' }}>
                                                        (+{child.children.length} nested sub-item{child.children.length > 1 ? 's' : ''} will also be copied)
                                                    </span>
                                                )}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </React.Fragment>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ copyModalShow: false })}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            disabled={this.state.selectedCopyIds.size === 0}
                            onClick={this.handleCopyConfirm}
                        >
                            Copy Selected ({this.state.selectedCopyIds.size})
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

        );
    }
}

export { MasterData };
